import * as React from "react";

import { noop } from "../../../../../../../Common/TypingUtils";
import { nullElement } from "../../../../TypingUtils";
import { MultipleUnitContainer } from "../../MultipleUnit/MultipleUnitContainer";
import { createUnitId, UnitId } from "../../UnitId/UnitId";
import { UnitLayoutKind } from "../../UnitLayoutKind";
import { IUnitRegistry } from "../../../Navigation/UnitRegistry/IUnitRegistry";
import { AbsoluteModelPath, AbsoluteResolvedModelPath } from "../../../../../../../Common/ModelPath/ModelPath";
import { GeneratedPageComponentType } from "../../../../../Engine/Form/GeneratedPage";
import { ClearPageMethod } from "../../../../../Engine/ActionCreators/UnitActionCreators";
import { ChildPage, UnitClearConfirmationSettings } from "../../Unit";
import { PropsPageActions } from "../../Types";

export interface ModalMultipleUnitInstanceProps {
    bindingPath: AbsoluteResolvedModelPath;
    index: number;
    unitId: UnitId;
    name?: string;
    component: GeneratedPageComponentType;
    instances: string[];
    pageActions?: PropsPageActions;
    hideEnableAutoValues?: boolean;
    enableHorizontalScrolling?: boolean;
    height?: number;
    layoutKind: UnitLayoutKind;
    optional?: boolean;
    showUnitBorder: boolean;
    unitRegistry: IUnitRegistry;
    pages: ChildPage[];
    clearConfirmationSettings: UnitClearConfirmationSettings;
    onRemoveUnit: (instance: string, id: UnitId) => void;
    onClearUnit: (instance: string, method: ClearPageMethod) => void;
    onCopyUnit: () => Promise<void>;
    onMount: () => void;
    onUnmount: () => void;
    onCheckModalUnitDataLoaded: (bindingPath: AbsoluteModelPath, instance: string) => void;
}

export class ModalMultipleUnitInstance extends React.Component<ModalMultipleUnitInstanceProps> {
    public render(): null | JSX.Element {
        if (this.props.unitId.instance == undefined) {
            return nullElement;
        }

        const ContentComponent = this.props.component;
        return (
            <MultipleUnitContainer
                onCopyUnit={this.props.onCopyUnit}
                showUnitBorder={this.props.showUnitBorder}
                enableHorizontalScrolling={this.props.enableHorizontalScrolling ?? false}
                bindingPath={this.props.bindingPath}
                height={this.props.height ?? 1000}
                index={this.props.index}
                instance={this.props.unitId.instance}
                parentUnitId={createUnitId(this.props.unitId.pageId)}
                layoutKind={this.props.layoutKind}
                pageActions={this.props.pageActions ?? {}}
                hideEnableAutoValues={this.props.hideEnableAutoValues}
                allowRemove={this.props.optional ? true : this.props.instances.length > 1}
                unitRegistry={this.props.unitRegistry}
                pages={this.props.pages}
                clearConfirmationSettings={this.props.clearConfirmationSettings}
                onHighlightUnit={noop}
                onRemoveUnit={this.props.onRemoveUnit}
                onClearUnit={this.props.onClearUnit}
                onMount={this.props.onMount}
                onUnmount={this.props.onUnmount}
                onCheckModalUnitDataLoaded={this.props.onCheckModalUnitDataLoaded}>
                <ContentComponent />
            </MultipleUnitContainer>
        );
    }
}
